// extracted by mini-css-extract-plugin
export default {"control":"Checkbox__control--Mu-","content":"Checkbox__content--SS-","hint":"Checkbox__hint--GpV","transparent":"Checkbox__transparent--Ca0"};